import React, { lazy, Suspense, useEffect, useState } from "react";
import { hireTeamUrlRouting, HireTeamContentConfig } from "../../../config/hire-team-content-config";
import "../hire-developer.css";
import BrandsCarousel from "../../../components/carousels/brands-carousel";
import StepsToHire from "../../../components/steps-to-hire";
import { useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

const LoadingScreen = lazy(() =>
  import("../../../components/loader/loading-screen")
);
const HeroBanner = lazy(() => import("./components/hero"));
import PricingCards from "../../../components/pricing-cards";
import SentryVideoTestimonial from "../../../components/videos/sentry-video";
const BenefitsList = lazy(() => import("./components/benefits-list"));
const TechnologyList = lazy(() => import("./components/technology-list"));
const ProductPartners = lazy(() =>
  import("../../../components/product-partners")
);
const ContactForm = lazy(() =>
  import("../../../components/forms/contact-form")
);
const TestimonialVideoPlayer = lazy(() =>
  import("../../../components/videos/testimonial-video")
);
const TestimonialCarousel = lazy(() =>
  import("../../../components/carousels/testimonial-carousel")
);

const HireTeamBaseLayout = () => {
  const [page, setPage] = useState(null);
  const location = useLocation();
  useEffect(() => {
    const currentPath = window.location.pathname;
    const findPath = hireTeamUrlRouting.find(
      (data) => data.pathname === currentPath
    );
    const newPage = HireTeamContentConfig.find(
      (data) => data.pageName === findPath?.pageName
    );

    if (newPage) {
      setPage(newPage);
    }
  }, [location.pathname]);
  if (!page) return null;
  return (
    <Suspense fallback={<LoadingScreen />}>
      <section className="hire-team layout-wrapper">
        <HeroBanner
          content={page.content}
          backgroundImage={page.backgroundImage}
          alt={page.alt}
          developer={page.developer}
        />
        <BrandsCarousel />
        <BenefitsList
          benefits={page.benefits || []}
          developer={page.developer}
        />
        <TechnologyList
          title={page.technologyList?.title}
          image={page.technologyList?.image}
          alt={page.technologyList?.alt}
        />
        <StepsToHire />
        <TestimonialCarousel />

        <Container>
          <Row>
            <Col xs="12" lg="6">
              <TestimonialVideoPlayer />
            </Col>
            <Col xs="12" lg="6">
              <SentryVideoTestimonial />
            </Col>
          </Row>
        </Container>
        <PricingCards developer={page.developer} />
        <ContactForm />

        <ProductPartners />
      </section>
    </Suspense>
  );
};

export default React.memo(HireTeamBaseLayout);
